<template>
  <div v-if="operator">
    <h1>Operator</h1>
    <v-btn :to="{name:'operators'}">
      <v-icon>chevron_left</v-icon>Operators
    </v-btn>
    <div v-if="operator.fileMini">
      <File :file="operator.fileMini" />
    </div>
    <h3>Information</h3>
    <table>
      <tr>
        <th>Account no</th>
        <td>{{operator.account_n}}</td>
      </tr>
      <tr>
        <th>Branch code</th>
        <td>{{operator.branch_code}}</td>
      </tr>
      <tr>
        <th>Category</th>
        <td>{{operator.categor}}</td>
      </tr>
    </table>
    <Address title="Subject property" :value="subjectProperty" v-if="subjectProperty" />
    <Client v-for="client in clients" :key="client.client_n" :value="client" />
    <Address
      title="Address"
      :value="address"
      v-for="address in addresses"
      :key="address.address_n"
    />
    <h3>Key dates</h3>
    <table>
      <tr>
        <th>Abortive</th>
        <td>{{operator.abortive_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Low fee inst</th>
        <td>{{operator.lowfeeinst | formatDate}}</td>
      </tr>
      <tr>
        <th>Low fee bill</th>
        <td>{{operator.lowfeebill | formatDate}}</td>
      </tr>
      <tr>
        <th>Abo warned</th>
        <td>{{operator.abowarned | formatDate}}</td>
      </tr>
      <tr>
        <th>Questionnaire in</th>
        <td>{{operator.qaire_in_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Agent</th>
        <td>{{operator.agent_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Lawyer</th>
        <td>{{operator.lawyer_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Llc in</th>
        <td>{{operator.llc_in_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Water in</th>
        <td>{{operator.water_in_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Deeds in</th>
        <td>{{operator.deeds_in_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Cntr del</th>
        <td>{{operator.cntr_del_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Mortgage offer</th>
        <td>{{operator.mtg_offr_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Exchange</th>
        <td>{{operator.exchange_d | formatDate}}</td>
      </tr>
      <tr>
        <th>Completion set</th>
        <td>{{operator.complset_d | formatDate}}</td>
      </tr>
    </table>
    <v-btn v-if="!operator.fileMini" @click="importOperator">
      <v-icon>settings</v-icon>Import into Autolaw
    </v-btn>
  </div>
</template>

<script>
import Address from "@/components/operator/Address";
import Client from "@/components/operator/Client";
import File from "@/components/link/File";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Operator",
  metaInfo() {
    return {
      title: "Operator",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { Address, Client, File },
  data() {
    return {
      operator: null,
      subjectProperty: null,
      clients: null,
      addresses: null
    };
  },
  methods: {
    fetchOperator() {
      nbmlaw
        .get(`/cors/admin/file/operators/${this.$route.params.id}`)
        .then(response => {
          // console.log(response.data);
          this.operator = response.data;
        });
    },
    fetchSubjectProperty() {
      nbmlaw
        .get(
          `/cors/admin/file/operators/${this.$route.params.id}/subjectProperty`
        )
        .then(response => {
          // console.log(response.data);
          this.subjectProperty = response.data;
        });
    },
    fetchClients() {
      nbmlaw
        .get(`/cors/admin/file/operators/${this.$route.params.id}/clients`)
        .then(response => {
          // console.log(response.data);
          this.clients = response.data;
        });
    },
    fetchAddresses() {
      nbmlaw
        .get(`/cors/admin/file/operators/${this.$route.params.id}/addresses`)
        .then(response => {
          // console.log(response.data);
          this.addresses = response.data;
        });
    },
    importOperator() {
      if (confirm("Are you sure?")) {
        nbmlaw
          .put(`/cors/admin/file/operators/${this.$route.params.id}`, null)
          .then(() => {
            // console.log(response.data);
            this.update();
          });
      }
    },
    update() {
      this.fetchOperator();
      this.fetchSubjectProperty();
      this.fetchClients();
      this.fetchAddresses();
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.update();
      }
    }
  }
};
</script>

<style>
</style>
